export default "__VITE_ASSET__CxKKPiw3__"